import React from "react";
import LiffInit from "./LiffInit";
import SearchForm from "./SearchForm";

function App() {
  return (
    <LiffInit>
      <div className="App">
        <SearchForm />
      </div>
    </LiffInit>
    // <div className="container mx-auto p-4">
    //   <SearchForm />
    // </div>
  );
}

export default App;
